import { ImageConstant } from "../../../constants/imageConstant";

const {
  avatar1,
  avatar2,
  avatar3,
  avatar4,
  avatar5,
  avatar6,
  avatar7,
  avatar8,
} = ImageConstant;

export const notifications = [
  {
    id: 1,
    fullName: "Felecia Rower",
    role: "Frontend Developer",
    message:
      "Cake pie jelly jelly beans. Marzipan lemon drops halvah cake. Pudding cookie lemon drops icing",
    avatar: avatar1,
    status: "online",
    unreadmessage: 0,
    date: "10 am",
  },
  {
    id: 2,
    fullName: "Adalberto Granzin",
    role: "UI/UX Designer",
    message:
      "Toffee caramels jelly-o tart gummi bears cake I love ice cream lollipop. Sweet liquorice croissant candy danish dessert icing. Cake macaroon gingerbread toffee sweet.",
    avatar: avatar2,
    status: "online",
    unreadmessage: 1,
    date: "11 am",
  },
  {
    id: 3,
    fullName: "Joaquina Weisenborn",
    role: "Town planner",
    message:
      "Soufflé soufflé caramels sweet roll. Jelly lollipop sesame snaps bear claw jelly beans sugar plum sugar plum.",
    avatar: avatar3,
    status: "busy",
    unreadmessage: 1,
    date: "12 pm",
  },
  {
    id: 4,
    fullName: "Verla Morgano",
    role: "Data scientist",
    message:
      "Chupa chups candy canes chocolate bar marshmallow liquorice muffin. Lemon drops oat cake tart liquorice tart cookie. Jelly-o cookie tootsie roll halvah.",
    avatar: avatar4,
    status: "online",
    unreadmessage: 2,
    date: "1 pm",
  },
  {
    id: 5,
    fullName: "Margot Henschke",
    role: "Dietitian",
    message:
      "Cake pie jelly jelly beans. Marzipan lemon drops halvah cake. Pudding cookie lemon drops icing",
    avatar: avatar5,
    status: "busy",
    unreadmessage: 0,
    date: "3 pm",
  },
  {
    id: 6,
    fullName: "Sal Piggee",
    role: "Marketing executive",
    message:
      "Toffee caramels jelly-o tart gummi bears cake I love ice cream lollipop. Sweet liquorice croissant candy danish dessert icing. Cake macaroon gingerbread toffee sweet.",
    avatar: avatar6,
    status: "online",
    unreadmessage: 2,
    date: "4 pm",
  },
  {
    id: 7,
    fullName: "Miguel Guelff",
    role: "Special educational needs teacher",
    message:
      "Biscuit powder oat cake donut brownie ice cream I love soufflé. I love tootsie roll I love powder tootsie roll.",
    avatar: avatar7,
    status: "online",
    unreadmessage: 0,
    date: "7 pm",
  },
  {
    id: 8,
    fullName: "Mauro Elenbaas",
    role: "Advertising copywriter",
    message:
      "Bear claw ice cream lollipop gingerbread carrot cake. Brownie gummi bears chocolate muffin croissant jelly I love marzipan wafer.",
    avatar: avatar8,
    status: "away",
    unreadmessage: 0,
    date: "10 pm",
  },
  {
    id: 9,
    fullName: "Bridgett Omohundro",
    role: "Designer, television/film set",
    message:
      "Gummies gummi bears I love candy icing apple pie I love marzipan bear claw. I love tart biscuit I love candy canes pudding chupa chups liquorice croissant.",
    avatar: avatar1,
    status: "offline",
    unreadmessage: 0,
    date: "10 pm",
  },
  {
    id: 10,
    fullName: "Zenia Jacobs",
    role: "Building surveyor",
    message:
      "Cake pie jelly jelly beans. Marzipan lemon drops halvah cake. Pudding cookie lemon drops icing",
    avatar: avatar2,
    status: "away",
    unreadmessage: 1,
    date: "10 am",
  },
];
